import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useDisclosure, useToast } from '@chakra-ui/react';
import { useHistory } from 'react-router';
import { useContext } from 'react';
import {
  getContractDetailsByNumber,
  getRequestContractTerminationList,
  getTerminationById,
} from '~/services/TerminationRequests';
import {
  TerminationRequestsContractView,
  TerminationRequestsContracVisualization,
  TerminationRequestsList,
} from '~/types/terminationRequests';
import { Pagination } from '~/types';
import { FilterContext } from '~/contexts/FilterContext/FilterContext';

export function useRequestContractTerminationList(
  page: number,
  search = '',
  status = '',
  solicitante = '',
  page_size: number | undefined = undefined,
  options: UseQueryOptions<Pagination<TerminationRequestsList>, unknown> = {},
  isAdmin = false,
): UseQueryResult<Pagination<TerminationRequestsList>, unknown> {
  const toast = useToast();
  const { groups, headOffices, branches } = useContext(FilterContext);
  return useQuery<Pagination<TerminationRequestsList>, unknown>(
    [
      'resquest-contract-termination-list',
      page,
      search,
      status,
      solicitante,
      page_size,
      { groups, headOffices, branches },
    ],
    () =>
      getRequestContractTerminationList(
        page,
        search,
        status,
        solicitante,
        page_size,
        {
          groups: groups?.map(e => e.value),
          headoffices: headOffices?.map(e => e.value),
          branches: branches?.map(e => e.value),
        },
        isAdmin,
      ),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro buscar dados, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
    },
  );
}
